import { CARD_ROOT_ELEMENT_INDEX } from 'common/constants';
import type { BBModel } from 'types/story';

export type CardRootType = keyof typeof CARD_ROOT_ELEMENT_INDEX;

/**
 * Read a card layout root by slot. `CARD_ROOT_ELEMENT_INDEX` is only the index map;
 * this checks that the slot exists and that its `type` matches.
 */
export function getCardRoot<T extends CardRootType>(elements: BBModel[], type: T): BBModel<T, BBModel[]> {
	const index = CARD_ROOT_ELEMENT_INDEX[type];
	const root = elements[index];
	if (!root) {
		throw new Error(`Card is missing ${type} root at index ${index}.`);
	}
	if (root.type !== type) {
		throw new Error(`Card root at index ${index} is "${root.type}", expected "${type}".`);
	}
	return root as BBModel<T, BBModel[]>;
}
